import React, { Component } from 'react';
import { Control, Errors } from 'react-redux-form/immutable';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import classnames from 'classnames';
import { FieldHelpIcon } from '../icon/FieldHelpIcon';
import { helpModalControl } from '../modals/HelpModalControl';

class LabeledCheckboxUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.handleHelpClick = this.handleHelpClick.bind(this);
    this.id = `i${uuid()}`;
  }

  handleHelpClick(e) {
    e.preventDefault();
    const { toggleHelpModal, helpModalId } = this.props;
    if (helpModalId) {
      toggleHelpModal(helpModalId);
    }
  }

  render() {
    const {
      model, label, value, readOnly, formGroupClassName, inline, helpModalId,
    } = this.props;
    return (
      <div className={classnames(['custom-control', 'custom-control custom-checkbox', ...formGroupClassName, { 'custom-control-inline': inline }])}>
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <Control.checkbox
          model={model}
          value={value}
          id={this.id}
          mapProps={{
            readOnly,
            className: ({ fieldValue }) => classnames({ 'custom-control-input': true, 'is-invalid': !fieldValue.valid }),
          }}
        />
        <label className="custom-control-label" htmlFor={this.id}>
          <div className="haz-help-icon-inline">
            <span>{label}</span>
            {helpModalId && <span><FieldHelpIcon handleClick={this.handleHelpClick} /></span>}
          </div>
        </label>
        <Errors
          model={model}
          component="div"
          wrapper={({ children: childs }) => <div className="invalid-feedback">{childs}</div>}
        />
      </div>
    );
  }
}

LabeledCheckboxUnwrapped.propTypes = {
  model: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  readOnly: PropTypes.bool,
  formGroupClassName: PropTypes.arrayOf(PropTypes.string),
  inline: PropTypes.bool,
  toggleHelpModal: PropTypes.func.isRequired,
  helpModalId: PropTypes.string,
};

LabeledCheckboxUnwrapped.defaultProps = {
  readOnly: false,
  value: 'on',
  formGroupClassName: [],
  inline: false,
  helpModalId: '',
};

export const LabeledCheckbox = helpModalControl(LabeledCheckboxUnwrapped);
